export default __webpack_public_path__ + "static/coperta-produse-hb-065e05b18aada950d0490c539a453768.jpg";